import { DataBean } from "../DataBean";

export class AgencyRole extends DataBean {



    public async deleteAgencyRole(idAgencyRole: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteAgencyRole_Number", [idAgencyRole]);
    }

    public async addAgencyRole(idAgency: any, idRole: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.transportguides.AgencyRole_addAgencyRole_Number_Number_Number", [idAgency, idRole, idEmployee]);
    }

    public async getAgencyRoleCatalog(idAgency: any, idRole: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getAgencyRoleCatalog_Number_Number_Number_Number", [idAgency, idRole, page, recordsPerPage]);
    }

}